import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-photo",
  "use": "spr-photo-usage",
  "viewBox": "0 0 80 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 80 64\" id=\"spr-photo\"><defs><path id=\"spr-photo_a\" d=\"M286 1632c-4.7 0-5.98-3.77-6-6v-44c0-4.7 3.77-5.98 6-6h2v-3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h5l3.72-7.45a1 1 0 0 1 .9-.55h20.76a1 1 0 0 1 .9.55L335 1576h19c4.7 0 5.98 3.77 6 6v44c0 4.7-3.77 5.98-6 6zm0-54c-.67 0-4 .23-4 4v7h7c1.18 0 1.97.77 2 1.97V1617c0 1.18-.77 1.97-1.97 2H282v7c0 .93.32 4 4 4h68c.66 0 4-.22 4-4v-7h-7c-1.18 0-1.97-.77-2-1.97V1591c0-1.18.77-1.97 1.97-2H358v-7c0-.66-.22-4-4-4zm34 46c-11.03 0-20-8.97-20-20s8.97-20 20-20 20 8.97 20 20-8.97 20-20 20zm0-38c-9.92 0-18 8.08-18 18s8.08 18 18 18 18-8.08 18-18-8.08-18-18-18zm0 31c-7.17 0-13-5.83-13-13s5.83-13 13-13 13 5.83 13 13-5.83 13-13 13zm0-24a11.01 11.01 0 0 0 0 22 11.01 11.01 0 0 0 0-22zm-31 24v-26h-7v26zm62 0h7v-26h-7zm-53-43h-8v2h8zm31.76-4h-19.52l-3 6h25.52z\" /></defs><use fill=\"#fff\" xlink:href=\"#spr-photo_a\" transform=\"translate(-280 -1568)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/photo.svg
// module id = 276
// module chunks = 0